module.exports = __webpack_public_path__ + "static/media/fr.67685aa0.png";